export default {
    path: '/place/placeAdd',
    name: 'PlaceAdd',
    component: () => import(/* webpackChunkName: "placeAdd" */ '../../views/place/components/placeAdd.vue')
}